import React, { Component } from 'react'
import { Button, Table } from 'antd'
import moment from 'moment'
import { files } from '@services/api'
import download from '@utils/download'
import { fileExt } from '@texts/files'

class ExportFiles extends Component<any, any> {
    state = {
        page: 1
    }

    downloadFile = async file => {
        let arrUrl = file.url.split('/')
        let nullIndex = arrUrl.indexOf('null')
        if (nullIndex > -1) arrUrl.splice(nullIndex, 1)
        let url = arrUrl.join('/')

        const downloadedFile = await files
            .assert(url)
            .then(res => new Blob([res.data], { type: fileExt[file.file_ext] }))
        download(downloadedFile, file.file_name)
    }

    columns: any[] = [
        {
            title: 'הורדה',
            key: 'download',
            width: 200,
            align: 'right',
            render: (_, record) => <Button onClick={() => this.downloadFile(record)}>הורד קובץ</Button>
        },
        {
            title: 'נוצר בתאריך',
            key: 'created_at',
            align: 'right',
            render: (_, record) => (
                <div>
                    {record.created_at ? moment(record.created_at).format('HH:mm DD/MM/YY') : 'אין תאריך העלאה'}
                </div>
            )
        },
        {
            title: 'שם הקובץ',
            key: 'file_name',
            align: 'right',
            render: (_, record) => <div>{record.file_name}</div>
        },
        {
            title: 'מזהה',
            key: 'id',
            align: 'right',
            render: (_, record) => <div>{record.id}</div>
        },
        {
            title: 'סיומת',
            key: 'file_ext',
            align: 'right',
            render: (_, record) => <div>{record.file_ext}</div>
        }
    ]

    render() {
        const { list, loading } = this.props
        const { page } = this.state
        const pageSize = 7

        return (
            <div>
                <Button
                    icon="reload"
                    onClick={this.props.getCommissionExportFiles}
                    style={{ marginBottom: '0.8rem' }}
                />
                <Table
                    className="center-table"
                    style={{ width: '100%' }}
                    rowKey="id"
                    loading={loading}
                    columns={this.columns}
                    dataSource={list.slice((page - 1) * pageSize, page * pageSize)}
                    pagination={{
                        total: list.length,
                        pageSize,
                        current: page,
                        hideOnSinglePage: true,
                        onChange: page => this.setState({ page })
                    }}
                />
            </div>
        )
    }
}

export default ExportFiles
